import BestellungFiliale from "@/entities/common/bestellung_filiale"
import MainLogic from "./main_logic"

export default class BaseLogic {
  mainLogic: MainLogic = MainLogic.getInstance()

  get filiale(): BestellungFiliale {
    return MainLogic.getInstance().filiale
  }
}
